import { render } from "./QuranProgramCard.vue?vue&type=template&id=1561b608&scoped=true"
import script from "./QuranProgramCard.vue?vue&type=script&lang=js"
export * from "./QuranProgramCard.vue?vue&type=script&lang=js"

import "./QuranProgramCard.vue?vue&type=style&index=0&id=1561b608&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1561b608"]])

export default __exports__